import { useTranslation } from 'react-i18next';

import { CustomDropZone } from '~/components/atoms/CustomDropZone';
import GridSelector from '~/components/atoms/GridSelector';
import { UploadedImagePreview } from '~/components/atoms/UploadedImagePreview';
import Accordion from '~/components/ui/Accordion/Accordion';
import { VCardPlusData } from '~/types/qrCode';

type VCardPlusImagesProps = {
  gridSelectorMaxWidth?: number;
  updateVCardPlusData?: () => void;
  createVCardPlusImage?: () => void;
  deleteVCardPlusImage?: () => void;
  vCardPlusData: VCardPlusData;
};
export default function VCardPlusImages({
  gridSelectorMaxWidth,
  updateVCardPlusData,
  vCardPlusData,
  createVCardPlusImage,
  deleteVCardPlusImage,
}: VCardPlusImagesProps) {
  const { t } = useTranslation();

  const addImages = (files) => {
    const newImages = files.map((itemFile) => {
      return {
        img: itemFile.previewLink,
        title: itemFile.name,
        imageStorageId: itemFile.imageStorageId,
        size: itemFile.size,
        microsite: vCardPlusData?.id,
        isLoading: true,
      };
    });

    newImages.forEach(async (item, index) => {
      createVCardPlusImage({
        title: item.title,
        image_id: item.imageStorageId,
        size: item.size,
        microsite: vCardPlusData?.id,
        position: index,
      });
    });
  };

  const setGridType = (type) => {
    updateVCardPlusData({
      images_view_type: type,
    });
  };

  const removeImage = async (id) => {
    await deleteVCardPlusImage(id);
  };

  return (
    <Accordion
      variant="child"
      defaultExpanded
      summary={t('template5:image')}
      details={
        <>
          <CustomDropZone
            maxSizeInKb={15000}
            fileTypes="PNG/JPEG"
            maxSize={15}
            onDrop={(files) => addImages(files)}
            acceptTypes="image/*"
          />
          {vCardPlusData?.images?.map((item) => {
            return (
              <UploadedImagePreview
                key={item.id}
                imageName={item?.title}
                imageSize={item?.size}
                id={item?.id}
                deleteHandler={removeImage}
                isLoading={item?.isLoading}
                imgSrc={item.image}
              />
            );
          })}
          <GridSelector
            maxWidth={gridSelectorMaxWidth}
            defaultImageType={vCardPlusData?.imagesViewType}
            setImagesType={(type) => setGridType(type)}
          />
        </>
      }
    />
  );
}
